import { Flex, Text } from '@chakra-ui/react';
import { ConfirmationDataPropTypes } from './ConfirmationDataPropTypes';
import { localisable } from '../../generic/localisable';
import React from 'react';
import { UNIT_FIELD_MAPPING, tableFlexStyles, tableItemProps } from './constant';
import { TENANT_FIELD_MAPPING } from './constant';

const RenderTable = ({ details, objTenant, title }: ConfirmationDataPropTypes.TDetails) => {
  return (
    <Flex {...tableFlexStyles}>
      <Text textStyle="h2">{title}</Text>
      <Flex direction={'column'}>
        {!!details.length &&
          details.map((detail, index) => {
            return objTenant[detail as keyof typeof objTenant] !== '' ? (
              <Flex
                {...tableItemProps}
                key={index}
                bg={index % 2 === 0 ? 'table.primary' : 'table.secondary'}
              >
                <Flex w={'40%'}>{TENANT_FIELD_MAPPING[detail as keyof typeof objTenant]}</Flex>
                <Flex w={'60%'}>{objTenant[detail as keyof typeof objTenant]}</Flex>
              </Flex>
            ) : null;
          })}
      </Flex>
    </Flex>
  );
};

const RenderUnitDetails = ({ unitDetails }: ConfirmationDataPropTypes.TUnitDetails) => {
  return (
    <Flex {...tableFlexStyles}>
      <Text textStyle="h2">{localisable.unitSectionTitle}</Text>
      <Flex direction={'column'}>
        {Object.keys(unitDetails).map((detail, index) => {
          return (
            <Flex
              {...tableItemProps}
              key={index}
              bg={index % 2 === 0 ? 'table.primary' : 'table.secondary'}
            >
              <Flex w={'40%'}>{UNIT_FIELD_MAPPING[detail as keyof typeof unitDetails]}</Flex>
              <Flex w={'60%'}>{unitDetails[detail as keyof typeof unitDetails]}</Flex>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};

export const ConfirmationDataTable = ({
  objTenant,
  showAltDetails,
  unitDetails,
}: ConfirmationDataPropTypes.IConfirmationDataTableProps) => {
  const tenantDetails = Object.keys(objTenant).filter((field) => {
    return !field.includes('alternate');
  });
  const alternateTenantDetails = Object.keys(objTenant).filter((field) => {
    return field.includes('alternate');
  });

  return (
    <>
      <Flex
        direction={{ base: 'column', sm: 'row' }}
        gap={'24px'}
        width={{ base: 'auto', sm: showAltDetails ? 'auto' : '50%' }}
      >
        <RenderTable
          objTenant={objTenant}
          details={tenantDetails}
          title={localisable.reserveFormTitle}
        />
        {showAltDetails && (
          <RenderTable
            objTenant={objTenant}
            details={alternateTenantDetails}
            title={localisable.alternateSectionTitle}
          />
        )}
      </Flex>
      <Flex w={{ base: 'auto', sm: '49.5%' }}>
        <RenderUnitDetails unitDetails={unitDetails} />
      </Flex>
    </>
  );
};
